import React from 'react'
import { connect } from 'react-redux'
import Icon from '../icon'
import Text from '../text'
import StatusPlaceholder from '../placeholder/status_placeholder'
import { me } from '../../initial_state'
import TabBar from '../tab_bar'
import MarketplaceListingCardPlaceholder from '../placeholder/marketplace_listing_card_placeholder'
import Image from '../image'
import Button from '../button'

class BusinessPreview extends React.PureComponent {
  render() {
    const { attrs } = this.props

    const name = attrs.get('name', 'Business name')
    const logo = attrs.get('logo', '')
    const cover = attrs.get('cover', '')
    const tagline = attrs.get('tagline', 'Tagline')
    const description = attrs.get('description', 'Description')
    const ctaTitle = attrs.get('cta_title', '')
    const ctaLink = attrs.get('cta_link', '')
    const website = attrs.get('website', 'www.example.com')
    const categories = attrs.get('categories', [])

    const hasCover = typeof cover === 'string' ? cover.indexOf('missing') === -1 : !!cover

    const pillItems = !!categories ? categories.map((s) => ({
      title: s.name,
    })) : undefined

    return (
      <div className={[_s.d, _s.calcH106PX, _s.bgPrimary, _s.w75PC, _s.minW460PX, _s.maxW640PX, _s.mt15, _s.px15, _s.py15, _s.radiusSmall, _s.overflowHidden, _s.boxShadowModal, _s.mlAuto, _s.mrAuto].join(' ')}>

        <Text weight='bold' className={_s.mb15}>Preview</Text>
        <div
          className={[_s.d, _s.flex1, _s.bgPrimary, _s.radiusSmall, _s.overflowHidden, _s.overflowYScroll, _s.border1PX, _s.borderColorSecondary].join(' ')}
        >
          <div className={[_s.d, _s.cursorNotAllowed, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.bottom0, _s.z2].join(' ')} />
          <div style={{ filter: 'opacity(0.675) grayscale(1)' }}>
            <div>
              {hasCover && <Image src={cover} width='100%' height='132' className={_s.d} /> }

              <div className={[_s.d, _s.w100PC, _s.jcCenter, _s.pt15, _s.px15].join(' ')}>
                <div className={[_s.d, _s.w100PC, _s.flexRow].join(' ')}>
                  <Image src={logo} width='80px' height='80px' className={_s.radiusSmall} />
                  <div className={[_s.d, _s.flex1, _s.pl15].join(' ')}>
                    <Text size='extraExtraLarge' weight='extraBold' color='secondary' className={_s.pt2}>{name}</Text>
                    <Text size='medium' color="secondary" className={_s.mt7}>{tagline}</Text>
                    <Text size='medium' color="secondary" className={_s.mt7}>{website}</Text>
                  </div>
                </div>
                <div className={[_s.d, _s.flex1, _s.w100PC, _s.mt15].join(' ')}>
                  <Text className={_s.w100PC} color="secondary">{description}</Text>
                  {
                    pillItems.length > 0 &&
                    <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt15].join(' ')}>
                      {
                        pillItems.map((p, i) => (
                          <div key={`pill-biz-preview-${i}`} className={[_s.d, _s.py5, _s.px10, _s.radiusSmall, _s.bgTertiary, _s.mr10, _s.mb5].join(' ')}>
                            <Text size='small'>{p.title}</Text>
                          </div>
                        ))
                      }
                    </div>
                  }
                </div>
              </div>
              {
                !!ctaTitle && !!ctaLink &&
                <div className={[_s.d, _s.w100PC, _s.pt15, _s.px15].join(' ')}>
                  <Button
                    isBlock
                    radiusSmall
                    backgroundColor='tertiary'
                    color='primary'
                    to='/businesses'
                    className={[_s.jcCenter, _s.aiCenter, _s.mlAuto].join(' ')}
                  >
                    <Text color='inherit' weight='bold' size='medium' className={_s.px5}>
                      {ctaTitle}
                    </Text>
                  </Button>
                </div>
              }
              <div className={[_s.d, _s.w100PC, _s.aiCenter, _s.jcCenter, _s.mlAuto, _s.mrAuto].join(' ')}>
                <div className={[_s.d, _s.w100PC, _s.flexRow, _s.borderBottom1PX, _s.borderColorSecondary, _s.maxH56PX].join(' ')}>
                  <TabBar tabs={[{title:'Shop', active: true}]} isLarge />
                </div>
              </div>
            </div>
          </div>
          <div className={[_s.d, _s.marketplaceItemGrid, _s.mt15, _s.px15].join(' ')}>
            <MarketplaceListingCardPlaceholder speed={0} interval={0} />
            <MarketplaceListingCardPlaceholder speed={0} interval={0} />
            <MarketplaceListingCardPlaceholder speed={0} interval={0} />
            <MarketplaceListingCardPlaceholder speed={0} interval={0} />
            <MarketplaceListingCardPlaceholder speed={0} interval={0} />
            <MarketplaceListingCardPlaceholder speed={0} interval={0} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  attrs: state.getIn(['business_editor', 'attrs']),
  account: state.getIn(['accounts', me]),
})

export default connect(mapStateToProps)(BusinessPreview)
